import { useNavigate } from "react-router-dom";
import { setNavigate } from "../../api/navigationService";
import { useEffect } from "react";

const NavigationProvider = ({ children }) => {
  const navigate = useNavigate();

  useEffect(() => {
    setNavigate(navigate);
  }, [navigate]);

  return children;
};

export default NavigationProvider;
